import { clearHtmlTag, onClickhref } from "utils";
import styles from "../index.less";
import Blank from "../components/blank";
import Address from "../../../asset/img/i/address.png"; // 地址图标
import Phone from "../../../asset/img/i/phone.png"; // 地址图标


const ExampleIntro = ({ data, pageId }: any) => {
  const moreUrl = `/hospital/${pageId}/jieshao`;
  return (data?.introduction) ? (
    <Blank className={styles.jianjieList} title="医院介绍" moreUrl={moreUrl}>
      <p className={styles.jianjieListText}>
        {clearHtmlTag(data?.introduction)}
      </p>
      <div className={styles.cardBottom}>
        {data?.address &&
          <div
            className={styles.address}
            onClick={() => {
              onClickhref(moreUrl);
            }}
          >
            <img src={Address} />
            <span>{data?.address}</span>
          </div>
        }
        {data?.phone &&
          <div
            className={styles.address}
            onClick={() => {
              onClickhref(moreUrl);
            }}
          >
            <img src={Phone} />
            <span>{data?.phone}</span>
          </div>
        }
      </div>
    </Blank>
  ) : <></>
}
export default ExampleIntro;